module.exports = __webpack_public_path__ + "img/ebook_conselho_carmico.5ae95dba.jpeg";